<template>
  <div class="order_list_top_text_min_width">
    <div class="justify-end ml-0 mr-0 mb-3">
      <p class="mt-4 mb-0 float-left">
        [검색결과 <font class="primary--text">{{ orderCount | comma }}</font
        >건 - 총 판매금액
        <font class="primary--text">{{ total_sales_amount | comma }}</font
        >원 / 총 지급 포인트
        <font class="primary--text"> {{ total_charged_mileage | comma }}</font
        >원]
      </p>
    </div>
    <div class="row justify-end ml-0 mr-0 mb-3">
      <v-select
        v-model="viewListCount"
        :items="viewListCountItem"
        label="50개씩 보기"
        persistent-hint
        single-line
        outlined
        dense
        class="pa-0"
        style="max-width: 150px; font-size: 14px"
        hide-details
        item-text="text"
        item-value="value"
        @change="viewListCountChange()"
      ></v-select>
    </div>

    <v-card class="manageCodeList col-12 mb-4 pb-0">
      <div class="row justify-end mt-0 mb-0">
        <v-btn
          small
          color="green"
          class="white--text ml-3 mr-3"
          @click.prevent="excelDownload"
          >엑셀 다운로드</v-btn
        >
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        calculate-widths
        item-key="order_id"
        class="pl-1 pr-1"
        hide-default-footer
        :loading="tableLoading"
        loading-text="잠시만 기다려주세요."
        :items-per-page="viewListCount"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.paid_at`]="{ item }">
          <p
            class="mt-3 text-center caption"
            v-html="$options.filters.defaultDate(item.paid_at)"
          ></p>
        </template>

        <template v-slot:[`item.order_id`]="{ item }">
          <p
            class="mt-3 text-center caption primary--text hover"
            @click="cafe24OrderPageMove(item.order_id)"
          >
            {{ item.order_id }}
          </p>
        </template>

        <template v-slot:[`item.member_id`]="{ item }">
          <p
            class="mt-3 text-center caption primary--text hover"
            @click="cafe24UserPageMove(item.member_id)"
          >
            {{ item.member_id }}
          </p>
        </template>

        <template v-slot:[`item.member_name`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.member_name }}
          </p>
        </template>

        <template v-slot:[`item.member_phone`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.member_phone }}
          </p>
        </template>

        <template v-slot:[`item.member_email`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.member_email }}
          </p>
        </template>

        <template v-slot:[`item.product_name`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.product_name }}
          </p>
        </template>
        <template v-slot:[`item.paid_amount`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.paid_amount | comma }}
          </p>
        </template>
        <template v-slot:[`item.charged_points`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.charged_points | comma }}
          </p>
        </template>
        <template slot="no-data">
          <div class="noDataProductInfos">내역이 없습니다.</div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="items.length > 0" class="text-center">
      <v-container class="pa-0">
        <v-row justify="center">
          <v-col cols="4" class="pa-0">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                :length="pageCount"
                @input="onPageChange"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 58px 0;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/filters.js";
import Excel from "@/libs/excel.js";
import ProgressDialog from "@/components/common/ProgressDialog.vue";

export default {
  data() {
    return {
      M,
      headers: [
        {
          text: "결제일시",
          align: "center",
          sortable: false,
          value: "paid_at",
          width: 100,
          filterable: false,
        },
        {
          text: "주문번호",
          align: "center",
          value: "order_id",
          sortable: false,
          width: 100,
          filterable: false,
        },
        {
          text: "주문자명",
          align: "center",
          value: "member_name",
          sortable: false,
          width: 100,
          filterable: false,
        },
        {
          text: "회원id",
          align: "center",
          value: "member_id",
          sortable: false,
          width: 100,
        },
        {
          text: "휴대전화",
          align: "center",
          value: "member_phone",
          sortable: false,
          width: 130,
          filterable: false,
        },
        {
          text: "이메일",
          align: "center",
          value: "member_email",
          sortable: false,
          width: 150,
          filterable: false,
        },
        {
          text: "상품명",
          align: "center",
          value: "product_name",
          sortable: false,
          width: 80,
          filterable: false,
        },
        {
          text: "판매금액",
          align: "center",
          value: "paid_amount",
          sortable: false,
          width: 90,
          filterable: false,
        },
        {
          text: "지급포인트",
          align: "center",
          value: "charged_points",
          sortable: false,
          width: 80,
          filterable: false,
        },
      ],
      items: [],
      page: 1,
      pageCount: 0,
      viewListCount: 50,
      viewListCountItem: [
        { text: "50개씩 보기", value: 50 },
        { text: "70개씩 보기", value: 70 },
        { text: "100개씩 보기", value: 100 },
      ],
      orderCount: 0,
      tableLoading: false,
      excelData: {
        Excel: null,
        totalLimit: 60000,
        limit: 500,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          paid_at: "가입일시",
          order_id: "주문번호",
          member_name: "주문자명",
          member_id: "회원id",
          member_phone: "휴대전화",
          member_email: "이메일",
          product_name: "상품명",
          paid_amount: "판매금액",
          charged_points: "지급포인트",
        },
      },
      groupList: [],
      is_load: false,
      total_sales_amount: 0,
      total_charged_mileage: 0,
    };
  },
  watch: {
    options: {
      handler() {
        this.$parent.$refs.searchComponent.execSearch(false);
      },
      deep: true,
    },
  },
  methods: {
    cafe24UserPageMove: function (user_id) {
      window.open(
        `https://${this.$store.state.mallId}.cafe24.com/admin/php/c/member_admin_d_f.php?mode=1&user_id=${user_id}&caller_no=&ord_year1=0&ord_month1=0&ord_day1=0&ord_year2=0&ord_month2=0&ord_day2=0&login_year1=0&login_month1=0&login_year2=0&login_month2=0&ord_period=0&login_period=0`,
        "_blank"
      );
    },
    cafe24OrderPageMove: function (order_id) {
      window.open(
        `https://${this.$store.state.mallId}.cafe24.com/admin/php/s_new/order_detail.php?order_id=${order_id}`,
        "_blank"
      );
    },
    setOrderList: function (params) {
      this.items = params.orders;
      this.orderCount = params.count;
      this.total_sales_amount = params.total_sales_amount;
      this.total_charged_mileage = params.total_charged_points;
      this.tableLoading = false;
    },
    // 엑셀 다운로드
    excelDownload: async function () {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      this.excelData.sheetData = [];
      this.excelData.totalCount = this.orderCount;

      if (this.items.length === 0) {
        alert("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }

      if (this.excelData.totalCount > this.excelData.totalLimit) {
        alert(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건\n이내로 검색하여 다운로드 해주세요."
        );
        return false;
      }

      // 엑셀 시작
      this.initExcelDownload();
    },

    /**
     * 엑셀 시작
     */
    initExcelDownload: function () {
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function () {
      this.$refs.ProgressDialog.show();
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
      }
      await this.getExcelDataAdd();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function () {
      if (this.excelData.offset >= this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }

      let excelPayload = this.$parent.$refs.OrderSearch.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;

      let search_orders = await M.api(
        M.entry("/get/mileage/orders"),
        excelPayload
      );

      if (search_orders.orders.length === 0) {
        await this.endExcel();
        return false;
      }

      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.excelData.sheetData = search_orders.orders;

      this.excelData.Excel.addSheet(this.excelData.sheetData);
      this.addExcel();
    },
    /**
     * 파일 다운
     */
    endExcel: async function () {
      setTimeout(() => {
        this.$refs.ProgressDialog.hide();
      }, 1500);

      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}_members`
      );
    },
    onPageChange: async function () {
      this.items = [];
      this.tableLoading = true;
      this.$parent.$refs.OrderSearch.setSearchPayload(
        this.viewListCount,
        this.page
      );
    },
    viewListCountChange: function () {
      this.page = 1;
      this.$parent.$refs.OrderSearch.setSearchPayload(
        this.viewListCount,
        this.page
      );
    },
  },
  components: {
    ProgressDialog,
  },
  mixins: [CommonMixin],
  filters: Filters,
};
</script>
